<template>
  <v-container>
    <h1>{{ $t('politicaDePrivacidade.title') }}</h1>
    <p><strong>{{ $t('politicaDePrivacidade.lastUpdate') }}</strong> {{ $t('politicaDePrivacidade.lastUpdateDate') }}</p>
    <p>
      {{ $t('politicaDePrivacidade.introduction') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.dataController.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.dataController.content') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.collectedData.title') }}</h2>
    <ul>
      <li v-for="(item, index) in $t('politicaDePrivacidade.sections.collectedData.items')" :key="index">{{ item }}</li>
    </ul>
    <h2>{{ $t('politicaDePrivacidade.sections.dataCollection.title') }}</h2>
    <ul>
      <li v-for="(item, index) in $t('politicaDePrivacidade.sections.dataCollection.items')" :key="index">{{ item }}</li>
    </ul>
    <h2>{{ $t('politicaDePrivacidade.sections.minorsData.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.minorsData.content') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.dataPurposes.title') }}</h2>
    <ul>
      <li v-for="(item, index) in $t('politicaDePrivacidade.sections.dataPurposes.items')" :key="index">{{ item }}</li>
    </ul>
    <h2>{{ $t('politicaDePrivacidade.sections.dataSharing.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.dataSharing.content') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.dataStorage.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.dataStorage.content') }}
    </p>
    <ul>
      <li v-for="(item, index) in $t('politicaDePrivacidade.sections.dataStorage.securityMeasures')" :key="index">{{ item }}</li>
    </ul>
    <p>
      {{ $t('politicaDePrivacidade.sections.dataStorage.additionalInfo') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.dataAccess.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.dataAccess.content') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.cookies.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.cookies.content') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.analytics.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.analytics.content') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.pushNotifications.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.pushNotifications.content') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.directMarketing.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.directMarketing.content') }}
    </p>
    <h2>{{ $t('politicaDePrivacidade.sections.finalProvisions.title') }}</h2>
    <p>
      {{ $t('politicaDePrivacidade.sections.finalProvisions.content') }}
    </p>
    <p>
      {{ $t('politicaDePrivacidade.sections.finalProvisions.contact') }}
    </p>
  </v-container>
</template>

<script>
export default {
  data(){},
  methods: {},
};
</script>